import { Link } from 'react-router-dom';
import { FieldName, SortOptions } from '../../utils/CustomTypes';
import General from '../../utils/GeneralUtils';
import { TableFields } from '../../utils/TableFields';
import SortLabel from '../SortLabel';
import TimePeriodIndicator from '../TimePeriodIndicator';
import UniversalTag from '../UniversalTag';

export function TableRowHeaderRfp({
  isAllSortingDisabled = false,
  showSubheader,
  currentSort,
  tableFields,
  onSort
}: {
  isAllSortingDisabled?: boolean,
  showSubheader: boolean,
  currentSort: SortOptions,
  tableFields: TableFields,
  onSort: (sortOptions: SortOptions) => void
}) {
  if (!showSubheader) return <></>
  return <>
    <div className='results-subheader' style={{ paddingLeft: 45 }}>
      {
        tableFields.isFieldVisible(FieldName.DATE_CONTRACT_EFFECTIVE) &&
          <div style={tableFields.getStyle(FieldName.DATE_CONTRACT_EFFECTIVE)}>
            <SortLabel fieldName={FieldName.DATE_CONTRACT_EFFECTIVE} isDisabled={isAllSortingDisabled ? true : !tableFields.isFieldSortable(FieldName.DATE_CONTRACT_EFFECTIVE)} currentSort={currentSort} onSort={onSort} />
          </div>
      }
      {
        tableFields.isFieldVisible(FieldName.DATE_CONTRACT_END) &&
          <div style={tableFields.getStyle(FieldName.DATE_CONTRACT_END)}>
            <SortLabel fieldName={FieldName.DATE_CONTRACT_END} isDisabled={isAllSortingDisabled ? true : !tableFields.isFieldSortable(FieldName.DATE_CONTRACT_END)} currentSort={currentSort} onSort={onSort} />
          </div>
      }
      {
        tableFields.isFieldVisible(FieldName.CONTRACT_DURATION) &&
          <div style={tableFields.getStyle(FieldName.CONTRACT_DURATION)}>
            <SortLabel fieldName={FieldName.CONTRACT_DURATION} isDisabled={isAllSortingDisabled ? true : !tableFields.isFieldSortable(FieldName.CONTRACT_DURATION)} currentSort={currentSort} onSort={onSort} />
          </div>
      }
      {
        tableFields.isFieldVisible(FieldName.VENDOR_NAME) &&
          <div style={tableFields.getStyle(FieldName.VENDOR_NAME)}>
            <SortLabel fieldName={FieldName.VENDOR_NAME} isDisabled={isAllSortingDisabled ? true : !tableFields.isFieldSortable(FieldName.VENDOR_NAME)} currentSort={currentSort} onSort={onSort} />
          </div>
      }
      {
        tableFields.isFieldVisible(FieldName.INSTITUTION_NAME) &&
          <div style={tableFields.getStyle(FieldName.INSTITUTION_NAME)}>
            <SortLabel fieldName={FieldName.INSTITUTION_NAME} isDisabled={isAllSortingDisabled ? true : !tableFields.isFieldSortable(FieldName.VENDOR_NAME)} currentSort={currentSort} onSort={onSort} />
          </div>
      }
    </div>
  </>
}

export function TableRowRFP({
  row,
  tableFields
}: {
  row: any,
  tableFields: TableFields
}) {
  return <>
    <div className='results-row-content'>
      <div className="results-row-main-row">
        {
          tableFields.isFieldVisible(FieldName.DATE_CONTRACT_EFFECTIVE) &&
            <div style={tableFields.getStyle(FieldName.DATE_CONTRACT_EFFECTIVE)}>
              { General.formatDate(row['date_contract_effective']) }
            </div>
        }
        {
          tableFields.isFieldVisible(FieldName.DATE_CONTRACT_END) &&
            <div style={tableFields.getStyle(FieldName.DATE_CONTRACT_END)}>
              { General.formatDate(row['date_contract_end']) }
            </div>
        }
        {
          tableFields.isFieldVisible(FieldName.CONTRACT_DURATION) &&
            <div style={tableFields.getStyle(FieldName.CONTRACT_DURATION)}>
              { row['contract_duration'] } years
            </div>
        }
        {
          tableFields.isFieldVisible(FieldName.VENDOR_NAME) &&
            <div style={tableFields.getStyle(FieldName.VENDOR_NAME)}>
              { row['vendor_name'] }
            </div>
        }
        {
          tableFields.isFieldVisible(FieldName.INSTITUTION_NAME) &&
            <div style={tableFields.getStyle(FieldName.INSTITUTION_NAME)}>
              { <><Link to={`/directory/institutions/${row['institution']['id'] || ''}`}>{ row['institution']['name'] }</Link> <UniversalTag category={row['institution']['type']} /></> }
            </div>
        }
      </div>
      {
        tableFields.isFieldVisible(FieldName.DESCRIPTION) &&
          <div style={tableFields.getStyle(FieldName.DESCRIPTION)}>
            <div className='desc-9' style={{ marginTop: 5, marginBottom: 5, paddingLeft: 330 }}>
              { row['description'] }
            </div>
          </div>
      }
      <div style={{ width: '100%', position: 'absolute', bottom: 0, left: 0, right: 0 }}>
        <TimePeriodIndicator
          minDate={General.addMonths(-24)}
          maxDate={General.addMonths(24)}
          fromDate={new Date(row['date_contract_effective'])}
          toDate={new Date(row['date_contract_end'])}
          contractDuration={row['contract_duration']}
        />
      </div>
    </div>
  </>
}
